import { render, staticRenderFns } from "./eventPage.vue?vue&type=template&id=462652cc&scoped=true"
import script from "./eventPage.vue?vue&type=script&lang=js"
export * from "./eventPage.vue?vue&type=script&lang=js"
import style0 from "./eventPage.vue?vue&type=style&index=0&id=462652cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462652cc",
  null
  
)

export default component.exports